import React, { useEffect, useState } from "react";
import {
  Box,
  CircularProgress,
  Grid,
  IconButton,
  Pagination,
  Tooltip,
  Typography,
} from "@mui/material";
import Layout from "app/layout/Layout";
import colors from "app/styles/colors";
import BreadCrumbs from "app/components/Breadcrumbs/Breadcrumbs";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import {
  Check,
  Close,
  Delete,
  PersonAdd,
  RemoveRedEye,
} from "@mui/icons-material";
import { SuccessToaster } from "app/components/Toaster/Toaster";
import CarService from "app/apis/Goeasy/Car/CarService";
import DriverList from "app/components/Dialog/DriverList";
import GoEasyCarBookingInfo from "app/components/Dialog/GoEasyCarBookingInfo";

function CarBookings() {
  const [dataList, setDataList] = useState([]);
  const [currentLinks, setCurrentLinks] = useState([]);
  const [listLoader, setListLoader] = useState(true);
  const [selectedData, setSelectedData] = useState({});
  const [showDialog, setShowDialog] = useState(false);
  const [showDetailDialog, setShowDetailDialog] = useState(false);

  const getData = async () => {
    try {
      setListLoader(true);
      let res = await CarService.getCarService();
      setCurrentLinks(res?.data?.meta?.links?.slice(1, -1));
      setDataList(res?.data?.data);
    } catch (error) {
      console.log("🚀 ~ getData ~ error:", error);
    } finally {
      setListLoader(false);
    }
  };

  const updateStatus = async (id, status) => {
    try {
      let res = await CarService.updateCarService({
        id,
        status,
      });
      SuccessToaster(res?.message);
      getData();
    } catch (error) {
      console.log("🚀 ~ updateStatus ~ error:", error);
    }
  };

  const handleDelete = async (id) => {
    try {
      let res = await CarService.deleteCarService({ id });
      SuccessToaster(res?.message);
      getData();
    } catch (error) {
      console.log("🚀 ~ updateStatus ~ error:", error);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <Layout>
      <DriverList
        open={showDialog}
        data={selectedData}
        handleClose={() => {
          getData();
          setShowDialog(false);
        }}
      />
      <GoEasyCarBookingInfo
        open={showDetailDialog}
        data={selectedData}
        onClose={() => {
          setShowDetailDialog(false);
        }}
      />
      <Box
        sx={{ backgroundColor: colors.lightGray, p: 3, borderRadius: "12px" }}
      >
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          sx={{ bgcolor: colors.white, p: 2, borderRadius: "12px" }}
        >
          <Grid item xs={6}>
            <Typography variant="body1" fontWeight="bold" color="initial">
              Car Bookings
            </Typography>
          </Grid>
          <Grid
            item
            xs={6}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <BreadCrumbs currentPage="Car Bookings" />
          </Grid>
        </Grid>

        <Box sx={{ mt: 2, bgcolor: colors.white, p: 2, borderRadius: 4 }}>
          {listLoader ? (
            <Box sx={{ textAlign: "center" }}>
              <CircularProgress color="success" />
            </Box>
          ) : (
            <>
              <TableContainer component={Paper} sx={{ my: 2 }}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow sx={{ bgcolor: colors.primary }}>
                      <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                        Name
                      </TableCell>
                      <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                        Contact
                      </TableCell>
                      <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                        Vehicle
                      </TableCell>
                      <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                        From
                      </TableCell>
                      <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                        To
                      </TableCell>
                      <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                        From Date
                      </TableCell>
                      <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                        To Date
                      </TableCell>
                      <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                        Pickup Time
                      </TableCell>
                      <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                        Status
                      </TableCell>
                      <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                        Action
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {dataList?.map((row, index) => (
                      <TableRow
                        sx={{
                          bgcolor: index % 2 ? colors.lightGray : "white",
                        }}
                        key={row.first_name}
                      >
                        <TableCell>
                          {row?.first_name} {row?.last_name}
                        </TableCell>
                        <TableCell>{row?.contact_no ?? "-"}</TableCell>
                        <TableCell>
                          {row?.car_brand} {row?.car_model}
                        </TableCell>
                        <TableCell>{row?.from_location ?? "-"}</TableCell>
                        <TableCell>{row?.to_location ?? "-"}</TableCell>
                        <TableCell>{row?.start_date ?? "-"}</TableCell>
                        <TableCell>{row?.end_date ?? "-"}</TableCell>
                        <TableCell>{row?.pick_up_time ?? "-"}</TableCell>
                        <TableCell sx={{ textTransform: "capitalize" }}>
                          {row?.status}
                        </TableCell>
                        <TableCell sx={{ display: "flex" }}>
                          <Box sx={{ display: "flex" }}>
                            <IconButton
                              onClick={() => {
                                setSelectedData(row);
                                setShowDetailDialog(true);
                              }}
                              size="small"
                            >
                              <Tooltip title="Show Detail">
                                <RemoveRedEye color="info" />
                              </Tooltip>
                            </IconButton>
                          </Box>
                          {row?.status == "pending" &&
                          row?.driver_id !== null ? (
                            <Box sx={{ display: "flex" }}>
                              <IconButton
                                onClick={() =>
                                  updateStatus(row?.id, "accepted")
                                }
                                size="small"
                              >
                                <Tooltip title="Accept Booking">
                                  <Check color="success" />
                                </Tooltip>
                              </IconButton>
                              <IconButton
                                onClick={() =>
                                  updateStatus(row?.id, "rejected")
                                }
                                size="small"
                              >
                                <Tooltip title="Reject Booking">
                                  <Close color="error" />
                                </Tooltip>
                              </IconButton>
                            </Box>
                          ) : row?.status == "pending" ? (
                            <Box sx={{ display: "flex" }}>
                              <IconButton
                                onClick={() => {
                                  setSelectedData(row);
                                  setShowDialog(true);
                                }}
                                size="small"
                              >
                                <Tooltip title="Attach Driver">
                                  <PersonAdd color="warning" />
                                </Tooltip>
                              </IconButton>
                              <IconButton
                                onClick={() =>
                                  updateStatus(row?.id, "rejected")
                                }
                                size="small"
                              >
                                <Tooltip title="Reject Booking">
                                  <Close color="error" />
                                </Tooltip>
                              </IconButton>
                            </Box>
                          ) : (
                            <Box sx={{ display: "flex" }}>
                              {row?.status == "accepted" && (
                                <IconButton
                                  onClick={() =>
                                    updateStatus(row?.id, "completed")
                                  }
                                  size="small"
                                >
                                  <Tooltip title="Complete Booking">
                                    <Check color="success" />
                                  </Tooltip>
                                </IconButton>
                              )}
                              <IconButton
                                onClick={() => {
                                  handleDelete(row.id);
                                }}
                                size="small"
                              >
                                <Tooltip title="Delete Booking">
                                  <Delete color="error" />
                                </Tooltip>
                              </IconButton>
                            </Box>
                          )}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </>
          )}
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Pagination
              variant="outlined"
              color="success"
              count={currentLinks?.length}
              onChange={(e, value) => getData(value)}
            />
          </Box>
        </Box>
      </Box>
    </Layout>
  );
}

export default CarBookings;
